// Dropdown menu
function togglenav() {
  var element = document.querySelector(".dropdown-nav");
  var breadcrumb = document.querySelector(".breadcrumb");
  element.classList.toggle("dropdown-nav-show");
  breadcrumb.classList.toggle("invisible");
}

// Video
function hideElement(element) {
  element.style.display = 'none';

  var parent = element.parentNode;
  var videoBanner = parent.querySelector('.video-banner');
  var rolexVideo = parent.querySelector('.rolex-video');

  if (videoBanner && rolexVideo) {
    videoBanner.style.display = 'none';
    rolexVideo.style.display = 'block';
    rolexVideo.play();
  }
}

//POPUP GALLERY
jQuery(function($) {
    $(document).ready(function() {
        var $gallery = $('.popup-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1],
                tCounter: ''
            },
            callbacks: {
                open: function() {
                    var total = this.items.length;
                    var $nav = $('<div class="mfp-circle-nav"></div>');
                    for (var i = 0; i < total; i++) {
                        $nav.append('<div class="circle" data-index="' + i + '"></div>');
                    }
                    $('.mfp-bottom-bar').append($nav);
                    updateCircleNav(this.index);
                },
                change: function() {
                    updateCircleNav(this.index);
                },
                close: function() {
                    $('.mfp-circle-nav').remove();
                },
                updateStatus: function(data) {
                    if (data.status === 'ready') {
                        updateCircleNav(this.index);
                    }
                }
            }
        });

        function updateCircleNav(index) {
            var $circles = $('.mfp-circle-nav .circle');
            $circles.removeClass('active');
            $circles.eq(index).addClass('active');
        }

        $(document).on('click', '.mfp-circle-nav .circle', function() {
            var index = $(this).data('index');
            $.magnificPopup.instance.goTo(index);
        });
    });
});

//MOBILE GALLERY SLIDER
jQuery(function($) {
    function initSlick() {
        if ($(window).width() < 768 && !$('.banner-mobile-slider').hasClass('slick-initialized')) {
            $('.banner-mobile-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
            });
        } else if ($(window).width() >= 768 && $('.banner-mobile-slider').hasClass('slick-initialized')) {
            $('.banner-mobile-slider').slick('unslick');
        }
    }

    initSlick();
    $(window).on('resize', initSlick);
});